import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import Axios from 'axios';
import { FORM_ERROR } from 'final-form';
import { renderErrors, SubmitError } from 'common/Forms/Utils';
import showToast from 'common/Toast';
import SubmitButton from 'common/Forms/SubmitButton';
import useFlags from '@/hooks/useFlags';
import { handleRadio } from '../RadioGroup';
import { handleSelect } from '../Util';
import GradesForm from './GradesForm';

export const gradesDefaultSettings = {
  grade_notebooks_by: 'section',
  notebook_possible_points: 5,
  section_possible_points: 5,
  show_percentages: false,
  student_challenge_highlight: 50,
  trends_highlight: 50
};

export default class Grades extends Component {
  static propTypes = {
    active: PropTypes.bool,
    isAssignmentsBasedGradingActive: PropTypes.bool,
    settings: PropTypes.shape({
      grade_notebooks_by: PropTypes.string,
      notebook_possible_points: PropTypes.string,
      show_percentages: PropTypes.bool,
      student_challenge_highlight: PropTypes.string,
      trends_highlight: PropTypes.string
    }),
    stafferPath: PropTypes.string.isRequired,
    updateState: PropTypes.func
  };

  static defaultProps = {
    active: false,
    isAssignmentsBasedGradingActive: false,
    settings: { ...gradesDefaultSettings },
    updateState: () => {}
  };

  constructor(props) {
    super(props);

    this.state = { submitting: false };
  }

  handleSubmit = async (values = {}) => {
    this.setState({ submitting: true });

    return Axios
      .put(this.props.stafferPath, values)
      .then((response) => {
        showToast('Save successful');
        this.props.updateState({ settings: response.data.data.settings });
        this.setState({ submitting: false });
      })
      .catch(error => this._handleSubmitError(error));
  };

  _getInitialValues() {
    return Object.assign({}, gradesDefaultSettings, this.props.settings);
  }

  _handleSubmitError(error) {
    this.setState({ submitting: false });
    return { [FORM_ERROR]: renderErrors(error.response.data.errors) };
  }

  render() {
    if (!this.props.active) return null;

    return (
      <div>
        <Form
          initialValues={this._getInitialValues()}
          mutators={{
            handleRadio: handleRadio,
            handleSelect: handleSelect
          }}
          render={({
            handleSubmit, submitError, form, values
          }) => (
            <form onSubmit={handleSubmit}>
              <GradesForm
                form={form}
                usesAssignmentsBasedGrading={
                  this.props.isAssignmentsBasedGradingActive &&
                  useFlags().usesAssignmentsBasedGrading
                }
              />

              <SubmitError error={submitError} />
              <hr />

              <div className="tw-text-right">
                <SubmitButton
                  submitButtonText="Update"
                  submitting={this.state.submitting}
                />
              </div>
            </form>
          )}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}
